import { alpha, Box, ButtonBase, styled } from "@mui/material";
import { Paragraph, Span } from "components/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import { navigations } from "../layout-parts/navigation";
import SidebarAccordion from "./SidebarAccordion";
import { useEditContext } from 'contexts/EditContext';
import { Fragment, useCallback, useEffect, useState } from "react"
import HTMLReactParser from 'html-react-parser';
import {generateSSOToken} from "services/authService";
import StaticVar from "config/StaticVar";


const NavItemButton = styled(ButtonBase)(({ theme, active }) => ({
  height: 44,
  width: "100%",
  borderRadius: 8,
  marginBottom: 4,
  padding: "0 18px",
  justifyContent: "flex-start",
  transition: "all 0.15s ease",
  ...(active && {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
  }),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ListLabel = styled(Paragraph)(({ theme, compact }) => ({
  fontWeight: 700,
  fontSize: "12px",
  marginTop: "20px",
  marginLeft: "15px",
  marginBottom: "10px",
  textTransform: "uppercase",
  transition: "all 0.15s ease",
  color: theme.palette.text.secondary,
  ...(compact && {
    opacity: 0,
    width: 0,
  }),
}));
const ExternalLink = styled("a")(({ theme }) => ({
  overflow: "hidden",
  whiteSpace: "pre",
  marginBottom: "8px",
  textDecoration: "none",
  color: theme.palette.text.primary,
}));
const StyledText = styled(Span)(({ theme, compact, active }) => ({
  whiteSpace: "nowrap",
  paddingLeft: "0.8rem",
  transition: "all 0.15s ease",
  fontSize: "13px",
  fontWeight: 500,
  color: active ? theme.palette.primary.main : theme.palette.text.secondary,
  ...(compact && {
    opacity: 0,
    width: 0,
  }),
}));
const BulletIcon = styled("div")(({ theme, active }) => ({
  width: 4,
  height: 4,
  marginLeft: "10px",
  marginRight: "8px",
  overflow: "hidden",
  borderRadius: "50%",
  background: active ? theme.palette.primary.main : theme.palette.text.disabled,
  boxShadow: active ? `0px 0px 0px 3px ${theme.palette.primary[200]}` : "none",
}));
const BadgeValue = styled(Box)(({ compact, theme }) => ({
  color: "white",
  fontSize: "12px",
  fontWeight: 500,
  padding: "1px 6px",
  overflow: "hidden",
  borderRadius: "300px",
  backgroundColor: theme.palette.primary.main,
  display: compact ? "none" : "unset",
})); // Common icon style

const Base64Icon = styled('img')({
  width: 18,
  height: 18,
  marginRight: '4px',
});

const iconStyle = (active) => ({
  fontSize: 18,
  marginRight: "4px",
  color: active ? "primary.main" : "text.secondary",
}); // ---------------------------------------------------------------

// ---------------------------------------------------------------
const menuDashboard = {
  _id: "1",
  name: "Home",
  type: "module",
  parent: null,
  level: 1,
  children: [
    {
      _id: "2",
      name: "Home",
      type: "page",
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-home"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" /></svg>',
      link: "/dashboard",
    },
  ],
}

const SSO = 
{
  _id: "99",
  name: "Portal SSO",
  type: "module",
  parent: null,
  level: 1,
  children: [
    {
      _id: "1",
      name: "Web Membership",
      type: "extLinkSSO",
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-home"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" /></svg>',
      link: `${StaticVar.URL_MEMBER}/oauth-success`,
      pathParams: {
        ssoTokenParam: "ssoToken",
        tokenGenerator: generateSSOToken,
      },
    },
    {
      _id: "2",
      name: "Web Payment",
      type: "extLinkSSO",
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-home"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" /></svg>',
      link: `${StaticVar.URL_PAYMENT}/oauth-success`,
      pathParams: {
        ssoTokenParam: "ssoToken",
        tokenGenerator: generateSSOToken,
      },
    },
    {
      _id: "3",
      name: "Web Event",
      type: "extLinkSSO",
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-home"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" /></svg>',
      link: `${StaticVar.URL_EVENT}/oauth-success`,
      pathParams: {
        ssoTokenParam: "ssoToken",
        tokenGenerator: generateSSOToken,
      },
    }
  ],
};

const MultiLevelMenu = ({ sidebarCompact, menu }) => {
  
  const { isEditing, setIsEditing } = useEditContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeRoute = (path) => (pathname === path ? 1 : 0);

  // Move the isBase64Icon function here so it's available throughout the component
  const isBase64Icon = (iconStr) => {
    return iconStr && (
      iconStr.startsWith('data:image') || 
      iconStr.startsWith('http') ||
      /^[A-Za-z0-9+/=]+$/.test(iconStr)
    );
  };

  const handleNavigation = (path) => {
    if (isEditing) {
      const confirmLeave = window.confirm('Perubahan belum disimpan. Yakin ingin keluar?');
      if (!confirmLeave) return;
      setIsEditing(false);
    }
    navigate(path);
  };

  const COMPACT = sidebarCompact ? 1 : 0;
  const combinedMenu = [menuDashboard, ...(Array.isArray(menu) ? menu : []), SSO];

  const renderLevels = (data = [], level = 0) => {
    if (!data || !Array.isArray(data)) return null;
    
    return data.map((item, index) => {
      // Handle module type (section headers)
      if (item.type === "module" || item.type === "label") {
        return (
          <Fragment key={item._id || index}>
            <ListLabel key={`label-${item._id || index}`} compact={COMPACT}>
              {item.name}
            </ListLabel>
            
            {item.children && item.children.length > 0 && (
              renderLevels(item.children, level)
            )}
          </Fragment>
        );
      }

      // Handle items with children (expandable menus)
      if (item.children && item.children.length > 0) {
        let accordionItem;
        
        if (isBase64Icon(item.icon)) {
          // For base64 icons, create a component on the fly
          const IconComponent = (props) => <Base64Icon src={item.icon} alt={item.name} {...props} />;
          
          accordionItem = {
            name: item.name,
            icon: IconComponent, // Pass as component
            path: item.link || '#',
          };
        } else {
          // For SVG icons, pass as string
          accordionItem = {
            name: item.name,
            icon: item.icon,
            path: item.link || '#',
          };
        }

        return (
          <SidebarAccordion 
            key={item._id || index} 
            item={accordionItem} 
            sidebarCompact={COMPACT}
          >
            {renderLevels(item.children, level + 1)}
          </SidebarAccordion>
        );
      } 
      // Handle external links
      else if (item.type === "extLink") {
        return (
          <ExternalLink
            key={item._id || index}
            href={item.link}
            rel="noopener noreferrer"
            target="_blank"
          >
            <NavItemButton key={item.name} name="child" active={0}>
              {item.icon ? (
                <Base64Icon src={item.icon} alt={item.name} />
              ) : (
                <span className="item-icon icon-text">{item.name.charAt(0)}</span>
              )}

              <StyledText compact={COMPACT} active={activeRoute(item.link)}>
                {item.name}
              </StyledText>

              <Box mx="auto" />

              {item.badge && (
                <BadgeValue compact={COMPACT}>{item.badge.value}</BadgeValue>
              )}
            </NavItemButton>
          </ExternalLink>
        );
      }
      // Handle SSO external links
      else if (item.type === "extLinkSSO") {
        return (
          <Box key={item._id || index}>
            <NavItemButton 
              key={item.name} 
              name="child" 
              active={0}
              onClick={() => handleExtLinkClick(item)}
            >
              {item.icon ? (
                isBase64Icon(item.icon) ? 
                  <Base64Icon src={item.icon} alt={item.name} /> : 
                  HTMLReactParser(item.icon)
              ) : (
                <BulletIcon active={activeRoute(item.link)} />
              )}

              <StyledText compact={COMPACT} active={0}>
                {item.name}
              </StyledText>

              <Box mx="auto" />

              {item.badge && (
                <BadgeValue compact={COMPACT}>{item.badge.value}</BadgeValue>
              )}
            </NavItemButton>
          </Box>
        );
      }
      // Handle regular menu items (pages)
      else {
        return (
          <Box key={item._id || index}>
            <NavItemButton
              key={item.name}
              className="navItem"
              active={activeRoute(item.link)}
              onClick={() => handleNavigation(item.link)}
            >
              {item.icon ? (
                isBase64Icon(item.icon) ? 
                  <Base64Icon src={item.icon} alt={item.name} /> : 
                  HTMLReactParser(item.icon)
              ) : (
                <BulletIcon active={activeRoute(item.link)} />
              )}

              <StyledText compact={COMPACT} active={activeRoute(item.link)}>
                {item.name}
              </StyledText>

              <Box mx="auto" />

              {item.badge && (
                <BadgeValue compact={COMPACT}>{item.badge.value}</BadgeValue>
              )}
            </NavItemButton>
          </Box>
        );
      }
    });
  };

  const handleExtLinkClick = async (item) => {
    try {
      if (item.pathParams && item.pathParams.tokenGenerator) {
        // Show loading indicator if needed (optional)
        const token = await item.pathParams.tokenGenerator();
        const paramName = item.pathParams.ssoTokenParam || "token";
        const url = `${item.link}?${paramName}=${token}`;
        window.open(url, "_blank");
      } else {
        // Regular external link without token
        window.open(item.link, "_blank");
      }
    } catch (error) {
      console.error("Failed to generate SSO token:", error);
      // Optional: Show error message to user
      alert("Failed to open external link. Please try again later.");
    }
  };

  return <>{renderLevels(combinedMenu)}</>;
};

export default MultiLevelMenu;
